import { useEffect, useState } from 'react'
import Placeholder from './Placeholder.jsx'
import { focusStyle } from '../lib/imageFocus.js'

// <img> that falls back to the branded placeholder if the file can't be loaded —
// e.g. an admin-uploaded photo whose blob is missing from the database.
// A #pos=top/bottom/left/right fragment on the URL shifts the object-fit:cover crop.
export default function ProductImage({ src, category, label, onFail, ...imgProps }) {
  const [failed, setFailed] = useState(false)
  useEffect(() => { setFailed(false) }, [src])

  if (!src || failed) return <Placeholder category={category} {...(label ? { label } : {})} />
  return (
    <img
      src={src}
      style={focusStyle(src)}
      onError={() => { setFailed(true); onFail?.(src) }}
      {...imgProps}
    />
  )
}
